import { isMobile$1 } from "@/js/global/helpers";
import { modal } from "@/js/modules/modal";
import { storeAvailabilityDrawer } from "@/js/modules/store-availability-drawer";
import { quickViewModal } from "@/js/modules/quick-view-modal";
import { productLightbox } from "@/js/modules/product-light-box";
import { flashAlertModal } from "@/js/modules/flash-alert-modal";
import { headerOverlay } from "@/js/modules/header-overlay";
import { backToTop } from "@/js/modules/back-to-top";
import { focusFormStatus } from '@/js/global/a11y-user'

import { sectionClasses } from "@/js/global/shopify-theme-sections";
import { handleTab } from "@/js/global/a11y-user";

import { n$2, e$2, u$1, o$1 } from "@/js/global/global";
import { pageTransition } from "@/js/modules/page-transition";
import { load } from "@/js/global/shopify-theme-sections";
import { initStockist, initGlobo } from "@/js/vendor/app-override.js";

// eslint-disable-next-line no-prototype-builtins
if (!HTMLElement.prototype.hasOwnProperty("inert")) {
  import("@/js/vendor/polyfill-inert-chunk");
}

// Detect theme editor
if (window.Shopify.designMode === true) {
  u$1(document.documentElement, "theme-editor");
  document.documentElement.classList.add("theme-editor");
} else {
  const el = n$2(".theme-editor-scroll-offset", document);
  el && el.parentNode.removeChild(el);
}

// Function to load all sections
const loadSections = () => {
  load("*");
  o$1({
    SelectedProductSection: null,
  });
};

// Call above function either immediately or bind on loaded event
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  loadSections();
} else {
  e$2(document, "DOMContentLoaded", loadSections);
}
if (
  isMobile$1({
    tablet: true,
    featureDetect: true,
  })
) {
  u$1(document.body, "is-mobile");
}

// Page transitions
pageTransition();

// a11y tab handler
handleTab();

// Apply contrast classes
sectionClasses();

// Load productlightbox
productLightbox();

// Quick view modal
const quickViewModalElement = n$2("[data-quick-view-modal]", document);
if (quickViewModalElement) {
  quickViewModal(quickViewModalElement);
}

// Setup modal
const modalElement = n$2("[data-modal]", document);
modal(modalElement);
const flashModal = n$2("[data-flash-alert]", document);
flashAlertModal(flashModal);

// Product availabilty drawer
const availabilityDrawer = n$2("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer);

// Setup header overlay
const headerOverlayContainer = document.querySelector("[data-header-overlay]");
headerOverlay(headerOverlayContainer);

// Init back to top button
backToTop();

// Note: we can't update the class where it's added (theme-setup.liquid) because it loads before window.Shopify.visualPreviewMode, preventing any logic checks from properly applying
window.addEventListener("load", function () {
  // Block animations within the visual preview mode only
  if (window.Shopify.visualPreviewMode) {
    document.documentElement.classList.remove("do-anim");
  }

  initStockist();
  initGlobo();
  focusFormStatus()
});
